<script>
  import { onMount, tick } from "svelte";
  import CloseButton from "./CloseButton.svelte";
  export let src;
  export let onClose;
  let video; // bind:video
  let isIframe = false;
  let isYoutube = false;
  let isVimeo = false;
  let videoContainer;

  $: if (/youtube/i.test(src)) {
    isYoutube = true;
    isIframe = true;
  } else if (/vimeo/i.test(src)) {
    isVimeo = true;
    isIframe = true;
  } else {
    isIframe = false;
  }

  async function focusVideo() {
    await tick();
    videoContainer.focus();
  }

  // TODO Implement focus trap
  // $: if (src) {
  //   focusVideo();
  // }

  import UA from "ua-parser-js";
  import { focusTrap } from "./utils";
  const ua = new UA();
  let mobile = ua.getResult().device["type"] == "mobile";

  function close() {
    src = false;
    if (onClose) {
      onClose();
    }
  }

  function fullscreen() {
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen();
    }
  }
</script>

<!-- /*____________ Markup ____________*/ -->
{#if src}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="background" on:click={close}></div>
  <div class="container" class:isMobile={mobile}>
    <header class="video-header">
      <CloseButton {close} useAbsolutePosition={false} />
    </header>
    <div class="video-container">
      {#if isIframe}
        <iframe
          id="video"
          title="Video"
          {src}
          allowfullscreen
          allow="autoplay"
          frameborder="0"
          bind:this={videoContainer}
        />
      {:else}
        <!-- svelte-ignore a11y-media-has-caption -->
        <video id="video" controls autoplay bind:this={video}>
          <source {src} type="video/mp4" />
        </video>
      {/if}
    </div>
  </div>
{/if}

<!-- /*____________ CSS ____________*/ -->
<style>
  .background {
    background: #000000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99101;
  }

  .container {
    display: grid;
    grid-template-rows: auto 1fr;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 99102;
  }

  .video-header {
    grid-row: 1;
    display: flex;
    justify-content: flex-end;
    padding: 0.5em;
  }

  .video-container {
    grid-row: 2;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 100vw;
    max-height: 100vh;
    margin: auto;
    overflow: hidden;
  }

  video,
  iframe {
    width: 100vw;
    height: 56.25vw; /* height:width ratio = 9/16 = .5625  */
    max-height: calc(100vh - 100px); /* close button height */
    max-width: 177.78vh; /* 16/9 = 1.778 */
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  /* landscape mobile */
  @media (orientation: landscape) {
    .isMobile .video-header {
      position: absolute;
      right: 0;
      top: 0;
      background: #000000;
      z-index: 999999;
      padding: 0.5em 0.75em 0.15em 0.75em;
    }

    .isMobile video,
    .isMobile iframe {
      height: 100vh;
      width: 100vw;
      max-width: 100vw;
      max-height: 100vh;
    }
  }
</style>
